import { DashboardSagas } from "./TaskManager";

export default [...DashboardSagas];
